import formReducer, {
  emptySingleInputField,
  emptyListField,
  emptyMultiSelectField,
  emptySelectField,
  formHelperMethodFactory,
} from 'reducers/FormReducer/FormReducer'
import {
  FormReducerSingleTextField,
  FormReducerSelectField,
  FormReducerListField,
  FormReducerMultiSelectField,
  PickByType,
  BaseValidationField,
  ValidationObject,
  withValidationFactory,
} from 'reducers/FormReducer/utils'

export interface ContentBlockFormReducerState {
  id: FormReducerSingleTextField
  title: FormReducerSingleTextField
  task: FormReducerSingleTextField
  apply_style_guide: FormReducerSelectField
  formatting: FormReducerSelectField
  character_limit: FormReducerSingleTextField
  guidelines: FormReducerListField
  guidelines_shortener: FormReducerListField
  restrictions: FormReducerListField
  additions: FormReducerSingleTextField
  should_keywords: FormReducerMultiSelectField
  must_keywords: FormReducerMultiSelectField
  omit_keywords: FormReducerMultiSelectField
  verbatim_must_claims: FormReducerMultiSelectField
  non_verbatim_optional_claims: FormReducerMultiSelectField
}

type PickContentBlockStateField<T> = PickByType<ContentBlockFormReducerState, T>

// Define the keys of the fields that match the correct element types
export type UpdateContentBlockInputField = PickContentBlockStateField<FormReducerSingleTextField>
export type UpdateContentBlockListField = PickContentBlockStateField<FormReducerListField>
export type UpdateContentBlockSelectField = PickContentBlockStateField<FormReducerSelectField>
export type UpdateContentBlockMultiSelectField = PickContentBlockStateField<FormReducerMultiSelectField>

// Get the keys of the fields that have a value and an error field
export type ContentBlockValidationFields = BaseValidationField<ContentBlockFormReducerState>

export const defaultContentBlockErrorObject: ValidationObject<'ContentBlockFormReducerState'> = {}
const withValidation = withValidationFactory(defaultContentBlockErrorObject)

// Define the initial state of the form
export const emptyContentBlockFormReducerState: ContentBlockFormReducerState = {
  id: withValidation(emptySingleInputField, 'id', ['requiredField', 'alphanumericField'], []),
  title: withValidation(emptySingleInputField, 'title', ['requiredField'], []),
  task: withValidation(emptySingleInputField, 'task', ['requiredField'], []),
  apply_style_guide: { ...emptySelectField, value: 'no' },
  formatting: withValidation(emptySelectField, 'formatting', ['requiredField'], []),
  character_limit: withValidation(emptySingleInputField, 'character_limit', ['numericField'], [], true),
  guidelines: emptyListField,
  guidelines_shortener: emptyListField,
  restrictions: emptyListField,
  additions: withValidation(emptySingleInputField, 'additions', [], []),
  should_keywords: withValidation(emptyMultiSelectField, 'should_keywords', [], ['nonEmptyField'], true),
  must_keywords: withValidation(emptyMultiSelectField, 'must_keywords', [], ['nonEmptyField'], true),
  omit_keywords: withValidation(emptyMultiSelectField, 'omit_keywords', [], ['nonEmptyField'], true),
  verbatim_must_claims: withValidation(emptyMultiSelectField, 'verbatim_must_claims', [], ['nonEmptyField'], true),
  non_verbatim_optional_claims: withValidation(
    emptyMultiSelectField,
    'non_verbatim_optional_claims',
    [],
    ['nonEmptyField'],
  ),
}

const contentBlockFormReducer = formReducer<'ContentBlockFormReducerState'>
export const contentBlockFormHelperFunctions = formHelperMethodFactory<'ContentBlockFormReducerState'>()

export default contentBlockFormReducer
